export interface ReconocimientosModel {
  nombre_reconocimiento: string;
  institucion_otorga: string;
  año: string;
  ciudad: string;
  documento: string;
}

export const initialValuesReconocimientoModel = {
  nombre_reconocimiento: "",
  institucion_otorga: "",
  año: "",
  ciudad: "",
  documento: "",
};
